// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3w7V8","lds-spinner":"Loader_lds-spinner__pZ6DH"};